<template>
  <ul class="p-0 m-0">
    <template
      v-for="(filter, index) in modelValue"
      :key="index">
      <li
        v-if="filter && !!filter.label && (filter.value !== undefined && filter.value !== null && filter.value !== '')"
        class="d-inline-block me-8 mb-8"
      >
        <v-button
          class="btn-icon rounded-pill d-flex shadow-none status-btn" 
          size="sm"
          variant="outline-primary"
          @click="emitRemoveFilter(filter)">
          <span>{{ filter.label }}</span>
          <v-icon class="rounded-pill" icon="close"/>
        </v-button>
      </li>
    </template>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';

export default defineComponent({
  name: 'VFilters',
  components: { VIcon, VButton },
  emits: ['removeFilter', 'update:modelValue'],
  props: {
    modelValue: {
      type: Array as PropType<Record<string, any>[]>,
      required: true,
    },
  },
  methods: {
    emitRemoveFilter(value: Record<string, string>) {
      this.$emit('removeFilter', value);
    },
  },
  
});
</script>
<style scoped>
  .status-btn{
    padding: 0 !important;
    padding-left: 10px !important;
    padding-right: 0 !important;
    font-size: 10px !important;
    min-height: 20px;
    display: flex;
    align-items: center;
  }
  
  .status-btn :deep(.icon-close) {
    font-size: 9px !important;
    padding: 6px;
    background-color: #000000 !important;
    color: #ffffff !important;
    margin-left: 6px;
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 0 50rem 50rem 0;
  }
</style>
